import { Controller } from "@hotwired/stimulus";

// Mobile bottom drawer for the page editor panel.
// Toggles between collapsed (just toggle bar visible) and expanded.
export default class extends Controller {
  static targets = ["panel", "arrow"];
  static values = { open: { type: Boolean, default: false } };

  toggle() {
    this.openValue = !this.openValue;
  }

  openValueChanged() {
    if (this.openValue) {
      this.panelTarget.classList.remove("translate-y-[calc(100%-3rem)]");
      this.panelTarget.classList.add("translate-y-0");
      this.arrowTarget.textContent = "\u25BC";
    } else {
      this.panelTarget.classList.remove("translate-y-0");
      this.panelTarget.classList.add("translate-y-[calc(100%-3rem)]");
      this.arrowTarget.textContent = "\u25B2";
    }
  }
}
